import React, { startTransition, useContext, useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AuthContext from '../../authContext';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { addSelectedCategory, resetSearchData } from '../../../redux/productSlice';
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from 'react-router-dom';
import navbarClasses from '../Navbar.module.css';

import allcat from "../../../../assets/icons/all-cat.svg";

export default function LanCurrSelect({ toggle }) {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);

  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const [hoveredSubCategoryId, setHoveredSubCategoryId] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const authCtx = useContext(AuthContext);
  const dispatch= useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/article-famille?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
        );
        setSubCategories(response.data || []);
      } catch (error) {
        console.error('Error fetching subcategories:', error);
      }
    };

    fetchSubCategories();
  }, []);

  const navigateInTransition = (to) => {
    startTransition(() => {
      navigate(to);
    });
  };

  const clearCategoryFilters = () => {
    localStorage.removeItem('stock');
    localStorage.removeItem('categories');
    localStorage.removeItem('collections');
    localStorage.removeItem('multiproductids');
    localStorage.removeItem('publishers');
    localStorage.removeItem('subCategories');
    localStorage.removeItem('subSubCategories');
    localStorage.removeItem('parentCategories');
    localStorage.removeItem('min_price');
    localStorage.removeItem('max_price');
    dispatch(resetSearchData());
  };

  const slugify = (value, fallback = 'category') => {
    const text = (value || fallback).toString().trim().toLowerCase();
    return text
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || fallback;
  };

  const getSubcategories = (parentId) => {
    return subCategories
      ?.filter((item) => Number(item.b_usr_parentcategorie_id) === Number(parentId))
      ?.sort((a, b) => (a.type_nom || '').localeCompare(b.type_nom || '')) || [];
  };

  const getChildSubcategories = (subCategoryId) => {
    return authCtx?.subsubCategories
      ?.filter((item) => Number(item.b_usr_articlecategorie_id) === Number(subCategoryId))
      ?.sort((a, b) => (a.nom || '').localeCompare(b.nom || '')) || [];
  };

  const handleAllCategoryClick = () => {
    clearCategoryFilters();
    dispatch(addSelectedCategory(null));
    navigateInTransition('/products');
  };

  const handleParentCategoryClick = (parentId, parentName) => {
    clearCategoryFilters();
    dispatch(addSelectedCategory(String(parentId)));
    navigateInTransition(`/cp/${slugify(parentName, 'category')}/${parentId}`);
  };

  const handleSubCategoryClick = (subCategoryId, subCategoryName, parentName, parentId) => {
    clearCategoryFilters();
    dispatch(addSelectedCategory(String(parentId)));

    const currentSubCategories = JSON.parse(localStorage.getItem('subCategories')) || [];
    currentSubCategories.push(subCategoryId);
    localStorage.setItem('subCategories', JSON.stringify(currentSubCategories));

    navigateInTransition(`/cp/${slugify(parentName, 'category')}/${slugify(subCategoryName, 'subcategory')}/${subCategoryId}`);
  };

  const handleChildSubCategoryClick = (childId, childName, subCategoryName, parentName) => {
    clearCategoryFilters();
    localStorage.setItem('subSubCategories', JSON.stringify([childId]));
    navigateInTransition(`/cp/${slugify(parentName, 'category')}/${slugify(subCategoryName, 'subcategory')}/${slugify(childName, 'subsubcategory')}/${childId}`);
  };

  return (
    <div style={{display:'flex',flexDirection:"row",gap:"1em"}}>
        <div style={{width:'fit-content',height:'fit-content',margin:'auto 0',padding:'.1em'}} onClick={toggle}>
          <Tooltip title="menu">
            <IconButton sx={{ p: 0 }}>
              <MenuIcon
                style={{
                  width: "30px",
                  height: "30px",
                  color: "var(--primary-color)",
                  margin: "0",
                }} />
            </IconButton>
          </Tooltip>
        </div>
        <div className={navbarClasses.categoriesNav}>
          <Tooltip title={language === 'eng' ? 'All Products' : 'Tous Nos Produits'}>
            <div
              className={navbarClasses.categoryIcon}
              onClick={handleAllCategoryClick}
            >
              <img src={allcat} alt="All Products" />
            </div>
          </Tooltip>

          {authCtx?.articleFamilleParents?.slice(0, 8).map((parent) => (
            <div
              key={parent.id}
              className={navbarClasses.categoryIconWrapper}
              onMouseEnter={() => {
                setHoveredCategoryId(parent.id);
                setHoveredSubCategoryId(null);
              }}
              onMouseLeave={() => {
                setHoveredCategoryId(null);
                setHoveredSubCategoryId(null);
              }}
            >
              <Tooltip title={parent.nom}>
                <div
                  className={navbarClasses.categoryIcon}
                  onClick={() => handleParentCategoryClick(parent.id, parent.nom)}
                >
                  <img src={parent.dark_image || allcat} alt={parent.nom} />
                </div>
              </Tooltip>

              {hoveredCategoryId === parent.id && getSubcategories(parent.id).length > 0 && (
                <div
                  className={navbarClasses.categoryDropdown}
                  onMouseEnter={() => {
                    setHoveredCategoryId(parent.id);
                  }}
                  onMouseLeave={() => {
                    setHoveredCategoryId(null);
                    setHoveredSubCategoryId(null);
                  }}
                >
                  <div className={navbarClasses.dropdownHeader}>{parent.nom}</div>
                  <div className={navbarClasses.dropdownContent}>
                    {getSubcategories(parent.id).map((sub) => (
                      <div
                        key={sub.id}
                        className={navbarClasses.dropdownItemWrapper}
                        onMouseEnter={() => setHoveredSubCategoryId(sub.id)}
                        onMouseLeave={() => setHoveredSubCategoryId(null)}
                      >
                        <div
                          className={navbarClasses.dropdownItem}
                          onClick={() => handleSubCategoryClick(sub.id, sub.type_nom || sub.nom, parent.nom, parent.id)}
                        >
                          <img src={sub.dark_image || allcat} alt={sub.nom} />
                          <span>{sub.type_nom || sub.nom}</span>
                          {getChildSubcategories(sub.id).length > 0 && (
                            <span className={navbarClasses.childIndicator}>›</span>
                          )}
                        </div>

                        {hoveredSubCategoryId === sub.id && getChildSubcategories(sub.id).length > 0 && (
                          <div className={navbarClasses.childDropdown}>
                            {getChildSubcategories(sub.id).map((child) => (
                              <div
                                key={child.id}
                                className={navbarClasses.childDropdownItem}
                                onClick={() =>
                                  handleChildSubCategoryClick(
                                    child.id,
                                    child.nom,
                                    sub.type_nom || sub.nom,
                                    parent.nom
                                  )
                                }
                              >
                                <img src={child.dark_image || allcat} alt={child.nom} />
                                <span>{child.nom}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
    </div>
  );
}
